import { useEffect, useState } from 'react';
import useFetchManifestLegs from '../../../../hooks/useFetchManifestLegs';
import { lmsStatusChips , handleDownloadFile } from '../../../../utils/utils';
import NoDataFound from '../../../global-components/no-data-found';
import {getLegPdf} from "../../../../api/lms";
import { useLocation } from 'react-router-dom';

type Props = {
  manifestNo: string;
  updateManifestLegNumber: (legNumber: number) => void;
};

const ManifestLegsTable = ({ manifestNo, updateManifestLegNumber }: Props) => {
  const location = useLocation();
  const { data, isLoading } = useFetchManifestLegs({ manifestNo });
  const manifest_no : any = new URLSearchParams(location.search).get("manifest_no");
  // const leg_no : any = new URLSearchParams(location.search).get("leg_no");
  const [selectedLegNumber, setSelectedLegNumber] = useState<number | null>(
    null
  );

  const hasData = data?.content?.length;

  useEffect(() => {
    if (!selectedLegNumber) return;

    updateManifestLegNumber(selectedLegNumber);
  }, [selectedLegNumber, updateManifestLegNumber]);

  useEffect(() => {
    if (hasData) {
      const firstLegNumber = data?.content[0]?.manifest_leg_no;
      setSelectedLegNumber(firstLegNumber);
    }
  }, [hasData, data]);

  const downloadPdf = (manifest_leg_no : number) => {
    getLegPdf(manifest_no , manifest_leg_no)
      .then((response) => {
        if (response?.data?.is_error) return;
        handleDownloadFile(
          response?.data?.content?.report,
          "Get BC Freight Manifest Report.pdf"
        );
      })
      .catch((e) => { });
  };

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Legs</h5>&nbsp;
        <span
          style={{
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '22.4px',
          }}
        >
          (Click on Leg ID to see its items, ULD & passengers)
        </span>
      </div>
      <div style={{ overflowX: 'auto' }} className='card-body p-2 h-auto'>
        <table className='table' id='lms-manifest-legs-table'>
          <thead className='ubbe-table-header'>
            <tr>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Leg ID
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Departure Location
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Departure Name
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Departure Date/Time
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Arrival Location
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Arrival Name
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Arrrival Date/Time
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Description
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Status
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Weight (lbs)
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Cubage (ft³)
              </th>
              <th className={`text-start ubbe-table-heading-text`} scope='col'>
                Download PDF
              </th>
            </tr>
          </thead>
          <tbody id='set_lanes_rows' className='bg-white'>
            {isLoading && (
              <tr>
                <td colSpan={9} className='text-center'>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'></span>
                  </div>
                </td>
              </tr>
            )}
            {!isLoading && !hasData && (
              <tr>
                <td colSpan={9}>
                  <NoDataFound />
                </td>
              </tr>
            )}
            {!isLoading &&
              data?.content.map((leg: any, index: number) => (
                <tr key={index}>
                  <td className='align-middle'>
                    <button
                      onClick={() => setSelectedLegNumber(leg.manifest_leg_no)}
                      style={{ color: '#251163', fontSize: '16px' }}
                      className={`btn btn-link p-0 text-link-underline`}
                    >
                      {leg.manifest_leg_no ?? 'N/A'}
                    </button>
                  </td>
                  <td className='align-middle'>
                    {leg.departure_location_code ?? 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {leg.departure_location_name ?? 'N/A'}
                  </td>
                  <td className='align-middle'>{`${leg.departure_date}/${
                    leg.departure_time ?? 'N/A'
                  }`}</td>
                  <td className='align-middle'>
                    {leg.arrival_location_code ?? 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {leg.arrival_location_name ?? 'N/A'}
                  </td>
                  <td className='align-middle text-break '>
                    {`${leg.departure_date}/${leg.departure_time ?? 'N/A'}`}
                  </td>
                  <td className='align-middle text-break '>
                    {leg.description ?? 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {lmsStatusChips(leg.status ?? 'N/A')}
                  </td>
                  <td className='align-middle'>
                    {leg.total_freight_weight_lbs ?? 'N/A'}
                  </td>
                  <td className='align-middle'>
                    {leg.max_cubage_ft3 ?? 'N/A'}
                  </td>
                  <td className='align-middle'>
                  <div className="d-flex my-auto text-end">
                  <button
                  className="btn btn-ubbe-new-blue"
                  style={{
                    marginRight: 5,
                    backgroundColor: !leg.manifest_leg_no ? '#999' : '',
                    opacity: !leg.manifest_leg_no ? 0.6 : 1,
                  }}
                  onClick={() => {
                  downloadPdf(leg.manifest_leg_no);
                  }}
                  disabled = {!leg.manifest_leg_no}
                  >
                  <span>Download</span>
                </button>
                </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManifestLegsTable;
